/**
 * @file 评论相关常量
 */

// 初始评论数据
export const InitInputValue = [
    {
        type: 'paragraph',
        children: [
            {
                text: '',
            },
        ],
    },
];

// 评论输入内容类型
export const CommentContentType = {
    Mention: 'mention', // mention 类型（@人、文档、ICafe）
    Link: 'link', // 超链接
    Image: 'image', // 图片
};

// Mention 类型
export const MentionType = {
    Contact: 'contact', // @人
    Doc: 'doc', // 文档、ICafe
};
